import { CITYS } from "@/constant";
import { getItem, setItem } from "@/utils/storage";

export default {
  namespaced: true,
  state: () => ({
    citys: getItem(CITYS) || [],
    cacheKeepAlive: [],
  }),
  mutations: {
    setCitys(state: any, citys: any) {
      state.citys = citys;
      setItem(CITYS, citys);
    },
    setKeepAlive(state: any, payload: string) {
      if (!state.cacheKeepAlive.includes(payload)) {
        state.cacheKeepAlive.push(payload);
      }
    },
    removeKeepAlive(state: any, payload: string) {
      state.cacheKeepAlive = state.cacheKeepAlive.filter(
        (item: any) => item !== payload
      );
    },
  },
};
